import { useEffect, useState, Fragment } from "react";
import { MapPin, Navigation, Compass } from "lucide-react";

export default function PassedConcerts({ t, lang }) {

  const [concerts, setConcerts] = useState([]);
  const [loading, setLoading] = useState(true);

  const formatDateTime = (date, date_end) => {

    const locale = lang === "fr" ? "fr-FR" : "en-US";

    const start = new Date(date);
    const end = date_end ? new Date(date_end) : null;

    const startDay = start.getDate();
    const startMonth = start.toLocaleDateString(locale, { month: "long" });
    const startYear = start.getFullYear();

    // Si pas de date_end
    if (!end) {
      return `${startDay} ${startMonth} ${startYear}`;
    }

    const endDay = end.getDate();
    const endMonth = end.toLocaleDateString(locale, { month: "long" });
    const endYear = end.getFullYear();

    // Même mois + même année
    if (startMonth === endMonth && startYear === endYear) {
      return `${startDay} – ${endDay} ${endMonth} ${startYear}`;
    }

    // Mois différents
    if (startYear === endYear) {
      return `${startDay} ${startMonth} – ${endDay} ${endMonth} ${startYear}`;
    }

    // Années différentes
    return `${startDay} ${startMonth} ${startYear} – ${endDay} ${endMonth} ${endYear}`;
  };


  useEffect(() => {
    fetch("/api/admin/concerts/concerts.php")
      .then(res => res.json())
      .then(data => {
        setConcerts(data.past);
        setLoading(false);
      })
      .catch(err => {
        console.error("Erreur chargement concerts", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <section className="py-5 text-center">
        <p>Chargement des concerts…</p>
      </section>
    );
  }

  return (
    <section id="concerts" className="py-5">
        <div className="past-concerts-wrapper">
          {concerts.map((p, i) => (
            <Fragment key={i}>
              <div className="past-concert-card row" style={{flexDirection:'row', opacity:'0.3'}}>
                <div className="card text-center h-100 bg-transparent" style={{ border: "none" }}>
                  <div className="card-body">
                    <h5
                      className="card-title"
                      style={{ fontFamily: "pangram-sans-semiBold", fontSize: "1.6rem" }}
                    >
                      {formatDateTime(p.date, p.date_end).toUpperCase()}
                    </h5>

                    <h3
                      className="card-text"
                      style={{
                        fontFamily: "pangram-sans-medium",
                        fontSize: "1rem",
                        marginBottom: "3rem",
                      }}
                    >
                      <MapPin size={16} style={{ marginBottom: "3px", marginRight: "3px" }} />
                      {p.loc.toUpperCase()}
                    </h3>

                    <h3
                      className="card-text"
                      style={{
                        color: 'black', /*getRandomColor(i)*/
                        fontFamily: "pangram-sans-bold",
                        fontSize: "2rem",
                        marginBottom: "1rem",
                      }}
                    >
                      {p.title.toUpperCase()}
                    </h3>

                    <h4
                      className="card-text"
                      style={{ fontFamily: "pangram-sans-regular", fontSize: "1.4rem" }}
                    >
                      {p.desc}
                    </h4>
                  </div>
                </div>
              </div>

              {/* Barre verticale sauf après le dernier */}
              {i < concerts.length - 1 && <div className="concert-divider"></div>}
            </Fragment>
          ))}
        </div>
    </section>
  );
}